import { createContext, useContext, useState, ReactNode } from 'react';

interface ConfigContextType {
  configId: string | null;
  setConfigId: (id: string) => void;
}

const ConfigContext = createContext<ConfigContextType | undefined>(undefined);

export const useConfigId = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfigId must be used within a ConfigProvider');
  }
  return context;
};

interface ConfigProviderProps {
  children: ReactNode;
  initialConfigId?: string | null;
}

export const ConfigProvider = ({ children, initialConfigId = null }: ConfigProviderProps) => {
  const [configId, setConfigId] = useState<string | null>(initialConfigId);

  return (
    <ConfigContext.Provider value={{ configId, setConfigId }}>{children}</ConfigContext.Provider>
  );
};
